export const CLIENT_CREATED_ACCOUNT = "CLIENT_CREATED_ACCOUNT";
export const CLIENT_PAID = "CLIENT_PAID";
